<template>
    <v-dialog
      v-model="showDialog.error"
      max-width="25%"
      persistent
    >
      <v-card>
        <v-card-text class="v-vard-text">
          <v-container>
            <div class="space"></div>
            <div class="success-ring">
              <v-icon class="content-icon">close</v-icon>
            </div>
            <div class="content-msg">{{errorMessage}}</div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn class="ensure" @click="ensureError">OK</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AddErrorDialog',
  props: {
    showDialog: Object,
    errorMessage: String
  },
  data () {
    return {
    }
  },
  methods: {
    ensureError () {
      this.showDialog.error = false
    }
  }
}
</script>

<style scoped>
.space {
  width: 156px;
  height: 60px;
  display: inline-block;
}
.success-ring {
  display: inline-block;
  width: 88px;
  height: 88px;
  border: 4px solid #FFC8C8;
  border-radius: 50%;
  text-align: center;
  padding: 20px auto !important;
}
.content-icon {
   color: #FF5252;
   font-size: 60px;
   text-align: center;
   line-height: 80px;
}
.content-msg {
  color: #595959;
  font-size: 16px;
  text-align: center;
  padding-top: 40px;
}
.ensure {
  background-color: #FF5252 !important;
  color: #fff;
  font-weight: bolder;
  font-size: 13px;
  padding: 0px 40px !important;
  margin: -10px auto 10px !important;
  border-radius: 2px;
}
</style>
